import { render, staticRenderFns } from "./ProductsRefund.vue?vue&type=template&id=68bbf654&"
import script from "./ProductsRefund.vue?vue&type=script&lang=js&"
export * from "./ProductsRefund.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRefund.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports